var _a;
import keys from "./keys";
var translate = (_a = {},
    _a[keys.LNG_af] = "Afrikaans",
    _a[keys.LNG_sq] = "Albanés",
    _a[keys.LNG_ar] = "Árabe",
    _a[keys.LNG_az] = "Azerí",
    _a[keys.LNG_bn] = "Bengalí",
    _a[keys.LNG_bg] = "Búlgaro",
    _a[keys.LNG_ca] = "Catalán",
    _a[keys.LNG_zh_CN] = "Chino (CHN)",
    _a[keys.LNG_zh_HK] = "Chino (HKG)",
    _a[keys.LNG_zh_TW] = "Chino (TAI)",
    _a[keys.LNG_hr] = "Croata",
    _a[keys.LNG_cs] = "Checo",
    _a[keys.LNG_da] = "Danés",
    _a[keys.LNG_nl] = "Neerlandés",
    _a[keys.LNG_en] = "Inglés",
    _a[keys.LNG_en_GB] = "Inglés (UK)",
    _a[keys.LNG_en_US] = "Inglés (US)",
    _a[keys.LNG_et] = "Estonio",
    _a[keys.LNG_fil] = "Filipino",
    _a[keys.LNG_fi] = "Finés",
    _a[keys.LNG_fr] = "Francés",
    _a[keys.LNG_de] = "Alemán",
    _a[keys.LNG_el] = "Griego",
    _a[keys.LNG_gu] = "Gujarati",
    _a[keys.LNG_ha] = "Hausa",
    _a[keys.LNG_he] = "Hebreo",
    _a[keys.LNG_hi] = "Hindi",
    _a[keys.LNG_hu] = "Húngaro",
    _a[keys.LNG_id] = "Indonesio",
    _a[keys.LNG_ga] = "Irlandés",
    _a[keys.LNG_it] = "Italiano",
    _a[keys.LNG_ja] = "Japonés",
    _a[keys.LNG_kn] = "Canarés",
    _a[keys.LNG_kk] = "Kazajo",
    _a[keys.LNG_ko] = "Coreano",
    _a[keys.LNG_lo] = "Laosiano",
    _a[keys.LNG_lv] = "Letonio",
    _a[keys.LNG_lt] = "Lituano",
    _a[keys.LNG_mk] = "Macedonio",
    _a[keys.LNG_ms] = "Malayo",
    _a[keys.LNG_ml] = "Malayalam",
    _a[keys.LNG_mr] = "Maratí",
    _a[keys.LNG_nb] = "Noruego",
    _a[keys.LNG_fa] = "Persa",
    _a[keys.LNG_pl] = "Polaco",
    _a[keys.LNG_pt_BR] = "Portugués (BR)",
    _a[keys.LNG_pt_PT] = "Portugués (POR)",
    _a[keys.LNG_pa] = "Punjabi",
    _a[keys.LNG_ro] = "Rumano",
    _a[keys.LNG_ru] = "Ruso",
    _a[keys.LNG_sr] = "Serbio",
    _a[keys.LNG_sk] = "Eslovaco",
    _a[keys.LNG_sl] = "Esloveno",
    _a[keys.LNG_es] = "Español",
    _a[keys.LNG_es_AR] = "Español (ARG)",
    _a[keys.LNG_es_ES] = "Español (ESP)",
    _a[keys.LNG_es_MX] = "Español (MEX)",
    _a[keys.LNG_sw] = "Suahili",
    _a[keys.LNG_sv] = "Sueco",
    _a[keys.LNG_ta] = "Tamil",
    _a[keys.LNG_te] = "Telugu",
    _a[keys.LNG_th] = "Tailandés",
    _a[keys.LNG_tr] = "Turco",
    _a[keys.LNG_uk] = "Ucraniano",
    _a[keys.LNG_ur] = "Urdu",
    _a[keys.LNG_uz] = "Uzbeco",
    _a[keys.LNG_vi] = "Vietnamita",
    _a[keys.LNG_zu] = "Zulu",
    _a);
export default translate;
//# sourceMappingURL=data:application/json;base64,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